import { clearAllBodyScrollLocks, disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { Plugin } from 'vue';
import '@/plugins/body-scroll/style.scss';

export type BodyScroll = {
  enable(target: HTMLElement | Element): void;
  disable(target: HTMLElement | Element): void;
  clear(): void;
};

const plugin: Plugin = {
  install(app) {
    let resizeObserver: ResizeObserver | null = null;
    let updateTimeout: ReturnType<typeof setTimeout> | null = null;
    let scrollbarWidth: number = 0;

    /**
     * Updates the scrollbar width.
     */
    function updateScrollbarWidth(): void {
      if (updateTimeout) {
        clearTimeout(updateTimeout);
      }

      updateTimeout = setTimeout(() => {
        scrollbarWidth = window.innerWidth - document.body.clientWidth; // Used document.body to handle cases with content overflow.

        document.body.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`);
      }, 100);
    }

    /**
     * Adds resize observer.
     */
    function addResizeObserver(): void {
      resizeObserver = new ResizeObserver(updateScrollbarWidth);
      resizeObserver.observe(window.document.body);

      updateScrollbarWidth();
    }

    if (window.ResizeObserver) {
      // Some older Safari versions don't support `ResizeObserver`
      addResizeObserver();
    }

    app.config.globalProperties.$bodyscroll = {
      /**
       * Enables the scrolling on the body.
       */
      enable(target: HTMLElement | Element): void {
        enableBodyScroll(target);
      },

      /**
       * Disabled the scrolling on the body.
       */
      disable(target: HTMLElement | Element) {
        disableBodyScroll(target);
      },

      /**
       * Clear all body scroll locks.
       */
      clear() {
        clearAllBodyScrollLocks();
      },
    };
  },
};

export default plugin;
